<div class="app-layout app-layout-auth">
  <div class="wrapper">
    <ng-container>
      <div class="auth" @enterLeaveHeight>
        <div class="login-form">
          <div class="logo">
            <img src="assets/images/bombardier-ssics-logo-black.svg" alt="" />
          </div>

          <form *ngIf="!oktaUrl" [formGroup]="loginFormGroup" (ngSubmit)="onLoginClick()">
            <div class="title">{{ 'login.login' | translate }}</div>
            <div class="form-group" *ngIf="loginInvalid">
              <div class="flex-row ng-invalid-comment">
                <i class="icon-attention-circled-alt fs20 mr5"></i>
                <div class="max">
                  <span class="fs16">{{ 'validation.login_failed' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ 'login.username' | translate }}</label>
              <dx-text-box
                formControlName="username"
                valueChangeEvent="keyup blur change focusout"
                placeholder="{{ 'login.username' | translate }}"></dx-text-box>
              <div
                class="error-message"
                *ngIf="isFormControlError(loginFormGroup.get('username'), 'required')">
                {{ 'validation.usernameRequired' | translate }}
              </div>
            </div>
            <div class="form-group">
              <label>{{ 'login.password' | translate }}</label>

              <div style="position: relative">
                <dx-text-box
                  formControlName="password"
                  placeholder="{{ 'login.password' | translate }}"
                  [(mode)]="passwordMode">
                </dx-text-box>
                <a
                  href="javascript:void(0)"
                  class="password_mode_btn"
                  (click)="onPasswordViewClick()"
                  [ngClass]="{
                    'icon-eye-c': passwordMode !== 'text',
                    'icon-eye-c-off': passwordMode === 'text',
                  }"></a>
              </div>

              <div
                class="error-message"
                *ngIf="isFormControlError(loginFormGroup.get('password'), 'required')">
                {{ 'validation.passwordRequired' | translate }}
              </div>
              <!--
                <div class="disclaimer grid-row text-medium">
                  <div>
                    {{ 'login.license_agreement' | translate }}<br />
                    <a class="reg-link" [href]="" target="_blank"
                      >{{ 'login.terms_and_conditions' | translate }}
                    </a>
                    {{ 'login.and' | translate }}
                    <a class="reg-link" [href]="" target="_blank">{{
                      'login.software_license_agreement' | translate
                    }}</a>
                  </div>
                </div> -->
            </div>
            <div class="submit acenter">
              <dx-button text="{{ 'login.login' | translate }}" [useSubmitBehavior]="true" />
            </div>
          </form>
          <div *ngIf="oktaUrl" class="submit acenter">
            <dx-button text="{{ 'login.login' | translate }}" (onClick)="redirectToOkta()" />
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
